<div class="unauthorized-container">
  <h1>{{ '403 - Unauthorized' | translate }}</h1>
  <p>{{ 'You do not have permission to access this page.' | translate }}</p>
  <button mat-raised-button color="primary" (click)="goHome()">
    {{ 'Go to Home' | translate }}
  </button>
</div>
